module.exports = "/_next/static/pages/about/Fragments/d531a9fa89be3de9055630072fd102a4.png";